import { createSelector } from 'reselect';

/**
 * Get a a files object representing the state of the submitted ref.
 *
 * @example
 *
 *   useSelector(state => getFiles(state, ref));
 *   // { files: [], pages: [], query: {} }
 *
 */
export const getFiles = createSelector(
  ({ files }) => files,
  (_, sessionId) => sessionId,
  ({ sessions, fileObjects }, sessionId) => {
    if (sessions[sessionId]) {
      return {
        ...sessions[sessionId],
        files: sessions[sessionId].files.reduce((acc, id) => {
          if (fileObjects[id]) acc.push(fileObjects[id]);
          return acc;
        }, []),
      };
    }

    return {
      files: null,
      pages: null,
      loading: false,
    };
  }
);

export const getUploading = ({ files }) => Object.values(files.uploading);

export const getUploaded = ({ files }) => Object.values(files.uploaded);

export const getInstructional = ({ files }, fileName) => files.instructionals[fileName] || null;
